exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-click[data-v-4e654e96]{cursor:default!important}.modal[data-v-4e654e96]{text-align:center}.modal[data-v-4e654e96]:before{display:inline-block;vertical-align:middle;content:\" \";height:100%}.modal .modal-dialog[data-v-4e654e96]{display:inline-block;text-align:left;vertical-align:middle}.modal .modal-dialog .modal-content[data-v-4e654e96]{border-radius:8px}.modal .modal-dialog .modal-content .modal-body[data-v-4e654e96]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center;padding:1rem}.modal .modal-dialog .modal-content .modal-body iframe[data-v-4e654e96]{border:none;border-radius:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e654e96","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/dashboard/banners/BannerTop.vue
// module id = Fb09
// module chunks = 0